const styles = (theme) => ({
  gridContainer: {
    padding: theme.spacing(2.5, 0),
    flexWrap: 'nowrap',
    gap: theme.spacing(2.5),
  },
  productImg: {
    width: 100,
    display: 'flex',
    alignItems: 'flex-start',
    '& img': {
      width: '100%',
      maxHeight: 'fit-content',
    },
  },
  details: {
    flexGrow: 1,
  },
  paddingBottom: {
    marginBottom: 0,
  },
  priceContainer: {
    width: '50%',
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(2.5),
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  giftOptionsContainer: {
    width: '50%',
    display: 'flex',
    alignItems: 'flex-start',
  },
  priceFullWidth: {
    width: '100%',
  },
});

export default styles;
